<template>
    <div>
        <div class="row" v-if="hideData">
            <div class="col-sm-9">
                <p>{{ $t('PERSONAL_AND_ADDRESS_DATA') }}</p>
            </div>
            <div class="col-sm-3">
                <button class="app-btn app-btn-primary pull-right" @click="hideData = !hideData">
                    {{ $t('CHECK_DATA') }}
                </button>
            </div>
        </div>
        <div v-else class="data-details">
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step5q1 === false">
                    <h4>{{ $t('PERSONAL_DATA') }}</h4>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('FIRST_NAME_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ user.firstName }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('LAST_NAME_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ user.lastName }}</span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('SECOND_NAME_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">
                                {{ user.patient.middleName }}
                            </span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('EMAIL_ADDRESS_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ user.email }}</span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('PHONE_NUMBER_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">
                                {{ `${user.dialingCode} ${user.phoneNumber}` }}
                            </span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('MAIDEN_NAME_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">
                                {{ user.patient.motherMaidenName }}
                            </span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('NATIONALITY_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userNationality }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('PESEL_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ user.pesel }}</span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('GENDER') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">
                                {{ userGender }}
                            </span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('BIRTH_DATE_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ user.birthDate }}</span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('IDENTIFICATION_DOCUMENT_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">
                                {{ userDocument }}
                            </span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('IDENTIFICATION_DOCUMENT_NUMBER_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">
                                {{ user.patient.documentNumber }}
                            </span>
                        </div>
                    </div>
                    <br />
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <surveyStep5Q1 :single="true" @cancel="step5q1 = false" @save="refreshForm" />
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step5q1 = true" v-if="step5q1 === false">
                        {{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img" />
                    </a>
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col-xs-12" v-if="step5q2 === false">
                    <h4>{{ $t('ADDRESS_DATA') }}</h4>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <label>{{ $t('STREET_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userAddress.street }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <label>{{ $t('BUILDING_NUMBER') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userAddress.buildingNumber }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <label>{{ $t('LOCAL_NUMBER') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userAddress.flatNumber }}</span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <label>{{ $t('CITY_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userAddress.city }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('POSTAL_CODE_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userAddress.zipCode }}</span>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <label>{{ $t('COUNTRY_COLON') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userCountry }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <surveyStep5Q2 :single="true" @cancel="step5q2 = false" @save="refreshForm" />
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 text-right">
                    <a @click="step5q2 = true" v-if="step5q2 === false">
                        {{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img" />
                    </a>
                </div>
            </div>
            <hr />
            <button class="app-btn app-btn-primary pull-right" @click="collapse">{{ $t('COLLAPSE') }}</button>
        </div>
    </div>
</template>

<script>
import surveyStep5Q1 from '../../modals/main-survey/survey-step5-q1.vue';
import surveyStep5Q2 from '../../modals/main-survey/survey-step5-q2.vue';
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            hideData: true,
            step5q1: false,
            step5q2: false,
        };
    },
    computed: {
        ...mapState(['user']),
        userAddress() {
            return this.user.address;
        },
        userNationality() {
            return this.user.patient.countryOfCitizenship != null ? this.user.patient.countryOfCitizenship.name : '';
        },
        userGender() {
            return this.user.patient.gender != null ? this.$t(this.user.patient.gender.name) : '';
        },
        userDocument() {
            const documentType =
                this.user.patient.documentType != null ? this.$t(this.user.patient.documentType.name) : null;
            const documentCountry =
                this.user.patient.documentIssueCountry != null ? this.user.patient.documentIssueCountry.code : null;
            return documentType != null ? `${documentType} ${documentCountry}` : '';
        },
        userCountry() {
            return this.userAddress.country != null ? this.userAddress.country.name : '';
        },
    },
    created() {
        this.fetchUser();
    },
    methods: {
        ...mapActions(['fetchUser']),
        collapse() {
            this.hideData = true;
            this.$scrollTo('#DanePersonalne', 500, { offset: -30 });
        },
        refreshForm() {
            this.fetchUser();
            this.step5q1 = false;
            this.step5q2 = false;
        },
    },
    components: {
        surveyStep5Q1,
        surveyStep5Q2,
    },
};
</script>

<style scoped>
.row-flex-align-bottom {
    display: flex;
    flex-wrap: wrap;
}

h4 {
    font-weight: 700;
}

a {
    cursor: pointer;
    display: block;
    margin-bottom: 15px;
}

.row-flex-align-bottom > div {
    align-self: flex-end;
}

label {
    font-size: 16px;
    font-weight: 400;
}

.data-details {
    margin-bottom: 100px;
}

.arrow-img {
    height: 7px;
    margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// personal-data.vue?d4593fd4